const Notifications = () => {
  return <></>;
};


Notifications.propTypes = {

};

export default Notifications;
